import React, { Component } from 'react';
import { BreadCrumb, Card } from '../../components';
import { Translate } from '../../contexts/Language';
import { Config } from '../../config';
import { Service } from '../../services';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';

export class Profile extends Component {
  constructor(props) {
    super(props);

    this.Refs = React.createRef();

    this.state = {
      formData: {
        firstName: '',
        lastName: '',
        password: null,
        passwordConfirm: null,
      },
      validation: {
        error: false,
        message: '',
      },
    };
  }

  componentDidMount() {
    Config.utilities.loadingFetch();

    Service.User.Profile().then(response => {
      if (response) {
        this.setState(prevState => ({
          formData: { ...prevState.formData, firstName: response.firstName, lastName: response.lastName },
        }));
      }

      Config.utilities.loadingFetch();
    });
  }

  onFormChange(value, key) {
    const { formData } = this.state;

    formData[key] = value;

    this.setState({
      formData,
    });
  }

  onSaveProfile() {
    const { formData } = this.state;

    if (this.isValid(formData)) {
      Config.utilities.loadingFetch();

      Service.User.SaveProfile(formData).then(response => {
        if (response.error) {
          this.setState({
            validation: {
              error: response.error,
              message: response.message,
            },
          });
        }

        Config.utilities.loadingFetch();
      });
    }
  }

  isValid(data) {
    VRules.firstName = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('First Name can not be empty.'),
    };

    VRules.lastName = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('Last Name can not be empty.'),
    };

    VRules.password = {
      Invalid: value => (VConditions.MinLength(value, 6) && value !== ''),
      Message: Translate('Password length must be minimum 6 characters.'),
    };

    VRules.passwordConfirm = {
      Invalid: value => (VConditions.MinLength(value, 6) && value !== ''),
      Message: Translate('Password length must be minimum 6 characters.'),
    };

    let error = Validator.Valid(data, this.Refs);

    if (!error.error) {
      if (data.password !== data.passwordConfirm) {
        error = {
          error: true,
          message: 'Check your password',
        };
      } else {
        error = {
          error: false,
          message: '',
        };
      }
    }

    this.setState({
      validation: error,
    });

    return !error.error;
  }

  render() {
    const { validation, formData } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Profile')} Name={Translate('Profile')} />
        <Card Title={Translate('Profile')} Description={Translate('Sets profile information')}>
          <form className="form-horizontal" name="saveForm" ref={this.Refs}>
            <ErrorMessage Validation={validation} />
            <div className="form-group row ml-1">
              <label htmlFor="firstName" className="col-sm-2 col-form-label">First Name</label>
              <div className="col-sm-4">
                <input className="form-control" type="text" id="firstName" name="firstName" value={formData.firstName} onChange={e => this.onFormChange(e.target.value, e.target.name)} />
              </div>
            </div>
            <div className="form-group row ml-1">
              <label htmlFor="lastName" className="col-sm-2 col-form-label">Last Name</label>
              <div className="col-sm-4">
                <input className="form-control" type="text" id="lastName" name="lastName" value={formData.lastName} onChange={e => this.onFormChange(e.target.value, e.target.name)} />
              </div>
            </div>
            <div className="form-group row ml-1 mt-5">
              <label htmlFor="password" className="col-sm-2 col-form-label">Password</label>
              <div className="col-sm-4">
                <input className="form-control" type="password" id="password" name="password" autoComplete="new-password" onChange={e => this.onFormChange(e.target.value, e.target.name)} />
              </div>
            </div>
            <div className="form-group row ml-1">
              <label htmlFor="passwordConfirm" className="col-sm-2 col-form-label">Password Confirm</label>
              <div className="col-sm-4">
                <input className="form-control" type="password" id="passwordConfirm" name="passwordConfirm" autoComplete="new-password" onChange={e => this.onFormChange(e.target.value, e.target.name)} />
              </div>
            </div>
            <div className="form-group row ml-1 pt-3">
              <label className="col-sm-2 col-form-label" />
              <div className="col-sm-4">
                <button type="button" className="btn btn-info" onClick={() => this.onSaveProfile()}>
                  <i className="far fa-save mr-2" />
                  <span>Save Profile</span>
                </button>
              </div>
            </div>
          </form>
        </Card>
      </>
    );
  }
}
